import { easasAlert } from "components/fragments/easas-global-fragment/EasasGlobalAlerts";
import { mountElementRoot } from "core/DynamicComponentLoader";
import { setEditMode } from "store/dashboard-store";

declare global {
    interface Window {
        EASAS: EASASLegacyConf;
        contextRoot: string;
        jsBasePath: string;
    }
}

window.EASAS = {
    mountRoot: mountElementRoot,
    easasAlert: easasAlert,
    dashboard: {
        setEditMode
    }
}

type EASASLegacyConf = {
	mountRoot: (element: HTMLElement) => void;
	easasAlert: (message: string) => void;
	dashboard: DashboardConf;
};

type DashboardConf = {
	setEditMode: (editMode: boolean) => void;
};

export {}